import React, { memo, Suspense } from 'react'
import Sider from './sider'
import Content from './content'
import { MainNav } from '../menu'
import { NavStoreProvider } from '../menu/NavStoreProvider'

const AppList = () => {
  return (
    <NavStoreProvider>
      <MainNav
        appId={1}
        menuData={[
          {
            name: '应用列表',
            navType: 'push',
            url: '/apps/$appId/tbs/1431?tpl=qzewm&vid=2381&token=$token',
            project: 'web',
            icon: '',
            show: true,
            showChildren: true,
            childrenIsTree: false,
            treeKey: null,
            params: null,
            children: [],
          },
        ]}
        rightElements={[{ type: 'user_avatar' }]}
        onMenuSelect={(nav) => {
          // routeTo(nav, appId, navigate)
          routeTo(nav)
        }}
        navType="push"
        mainNav="horizontal"
        mainNavRenderLevel={1}
        secondNavRenderLevel={1}
      >
        {/* 这里可以设计一个 loading 或者留白 */}
        <Suspense fallback={<div>...</div>}>
          <div className="h-full w-full flex">
            <Sider />
            <Content />
          </div>
        </Suspense>
      </MainNav>
    </NavStoreProvider>
  )
}

export default memo(AppList)
